// extracted by mini-css-extract-plugin
module.exports = {"container":"visual-story-m__container__3e208","cta":"visual-story-m__cta__2rE9a","ampIcon":"visual-story-m__ampIcon__qp8af"};